function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import styles from "./Checkbox.module.sass";
import Icon from "../../Icon/Icon";
const Checkbox = ({
  children,
  value,
  onChange,
  onClick,
  className,
  style,
  ...attributes
}) => /*#__PURE__*/React.createElement("label", {
  className: `${styles["label"]} ${className || ""}`,
  style: style,
  onClick: onClick
}, /*#__PURE__*/React.createElement("input", _extends({
  type: "checkbox",
  checked: value,
  onChange: onChange
}, attributes)), /*#__PURE__*/React.createElement(Icon, {
  className: styles["checkmark"],
  name: "checkmark"
}), value === true ? /*#__PURE__*/React.createElement("strong", null, children) : /*#__PURE__*/React.createElement("small", null, children));
export default Checkbox;